export default {"src":"/_next/static/media/ic-read-more.ecf0986c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};